<template>
  <div class="py-4 d-flex">
    <h2 class="py-3 text-dark fw-bold">{{ title }}</h2>
  </div>
  <div>
    <div class="d-grid gap-4" grid>
      <StatCardComp
        v-for="key in Object.keys(summary)"
        :key="key"
        :title="toCamelCase(key)"
        :icon="summary[key].info.icon ? summary[key].info.icon : ''"
        :value="summary[key].count.total"
        details="asdsad"
        :smallfont="
          summary[key].info.smallfont ? summary[key].info.smallfont : false
        "
      >
        <template #details>
          <p
            stat-detail
            v-for="detail in summary[key].details"
            :key="detail"
            v-html="detail"
          ></p>
        </template>
      </StatCardComp>
    </div>
  </div>
</template>

<script>
import StatCardComp from "@/components/dashboard/StatCardComp.vue";
import utils from "@/libraries/utils/utils";

export default {
  name: "SummaryComp",
  props: {
    title: {
      type: String,
      required: false,
    },
    summary: {
      type: Object,
      required: false,
    },
  },
  components: {
    StatCardComp,
  },
  methods: {
    toCamelCase(string) {
      return utils.toCamelCase(string);
    },
    money(string) {
      return utils.money(string);
    },
  },
};
</script>

<style scoped>
[grid] {
  justify-content: flex-start;
  grid-template-columns: 1fr 1fr;
}
[stat-detail] {
  font-size: 13px;
  line-height: 0px;
  color: rgb(102, 102, 102);
  font-weight: 500;
}
[stat-detail] span {
  color: black;
}
</style>
